<template>
  <c-layout :spinning="page.loading">
    <div class="loginApi-bg"/>
    <div class="loginApi-div">
      <div class="title" style="margin-left: 0px;">钟山区财政预决算后台管理系统</div>
      <a-input autocomplete="off" placeholder="用户名" type="text" v-model="username" class="input-text"></a-input>
      <a-input autocomplete="off" placeholder="密码" type="password" v-model="password" class="input-text"></a-input>
      <a-button style="width:100%;" type="primary" @click="submit" class="loginApi-button">立即登录</a-button>
    </div>
  </c-layout>
</template>

<script>
import commonApi from '@/api/CommonApi'
import {setToken, getToken, setUserInfo, getUserInfo} from '@/utils/sessionUtils'
import md5 from 'js-md5'

export default {
  name: 'Login',
  data() {
    return {
      page: {
        loading: false
      },
      username: '',
      password: '',
      msg: '拖动滑块验证',
      checked: false,
      show: {
        checkCode: false,
      }
    }
  },
  activated() {
    this.checkLoginStatus()
  },
  mounted() {
    // this.$router.push('/sys/index')
  },
  methods: {
    checkLoginStatus() {
      let token = getToken()
      let userInfo = getUserInfo()
      this.$store.state.token = token
      this.$store.state.userInfo = userInfo
      if (!!(token && userInfo)) {
        this.$router.push('/manage/index')
      }
    },
    async submit() {
      const _this = this
      if (!(_this.username.trim() && _this.password.trim())) {
        _this.$message.error("用户名或密码不能为空")
        return
      }
      let encPassword = ''
      let data = {
        username: _this.username,
        password: md5(_this.password)
      };
      let token = await _this.getToken(data)
      if (token.status) {
        setToken(token.data)
        let userInfo = await _this.getUserInfo()
        if (userInfo.status) {
          setUserInfo(userInfo.data)
          console.log(userInfo.data.role)
          if (userInfo.data.role === '单位用户') {
            _this.$router.push('/manage/welcome?r='+Math.random())
          } else {
            _this.$router.push('/manage/publish-view?r='+Math.random())
          }
        } else {
          _this.$message.error('登录失败')
        }
      }
    },
    getToken(data) {
      return commonApi.login(data).then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return
        }
        return Promise.resolve({status: true, data: result.data})
      }).catch(error => {
        console.error('出现错误:', error);
        return Promise.resolve({status: false, data: error})
      })
    },
    getUserInfo() {
      return commonApi.getUserInfo().then(result => {
        if (result.status !== 200) {
          this.$message.error(result.message);
          return;
        }
        if (result.data !== null) {
          return Promise.resolve({status: true, data: result.data})
        }
      }).catch(function (error) {
        console.error('出现错误:', error);
        return Promise.resolve({status: false, data: error})
      })
    },
  }
}
</script>
<style lang="less" scoped>
@import "~@public/color.less";

.loginApi-bg {
  background: url(~@assets/timg.jpg) no-repeat center;
  background-size: 100%;
  overflow: hidden;
  height: 100vh;
  width: 100%;
  filter: blur(100px);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
}

.loginApi-div {
  margin: 0 auto;
  min-height: 420px;
  max-width: 420px;
  padding: 300px 40px 40px;
  background-color: #ffffff;
  border-radius: 4px;
  box-sizing: border-box;
}

.title {
  margin: 10px 0 0 -58px;
  padding: 18px 10px 18px 60px;
  background: @primary-color;
  position: relative;
  color: #fff;
  font-size: 16px;
}

.input-text {
  height: 50px;
  box-sizing: border-box;
  margin: 16px 0;
}

.loginApi-button {
  height: 50px;
  border: none;
}
</style>
